;(function() {
  'use strict'

  service.$inject = ["$state"];
  angular.module('app.action').factory('actionService', service)

  /* @ngInject */
  function service($state) {
    var actions = [
      { type: 'post', letter: 'P' }, // deprecated
      { type: 'message', letter: 'M' },
      { type: 'element', letter: 'E' },
      { type: 'survey', letter: 'S' },
    ]

    return {
      perform: perform,
    }

    function perform(code) {
      var action = actionFromCode(code)
      var state
      var params = {}

      switch (action.letter) {
        case 'P':
        case 'M':
          state = 'app.portal.message'
          params.id = action.payload
          break
        case 'E':
          state = 'app.portal.element'
          params.id = action.payload
          break
        case 'S':
          state = 'app.survey'
          params.id = action.payload
          break
        default:
          state = 'app.public'
      }

      route(state, params)
    }

    function actionFromCode(code) {
      var letter = code[1]
      var payload = code.substr(2)
      var action = _.clone(_.find(actions, { letter: letter })) || {}
      action.payload = payload
      return action
    }

    function route(state, params) {
      $state.go(state, params, { location: 'replace' })
    }
  }
})()
